import Box from '@mui/material/Box';
import { type Theme } from '@mui/material/styles';
import React from 'react';
import { l } from 'app/blocks/common/codes';
import warningIcon from './icons/warning.svg';
import wifiIcon from './icons/wifi.svg';
import type { StaticSearchErrorKind } from '../api';

export function StaticSearchErrorPanel({ variant }: { variant: StaticSearchErrorKind }) {
    const messageCode =
        variant === 'connection'
            ? 'SEARCH_CODES.STATIC.STATES.CONNECTION_ERROR'
            : 'SEARCH_CODES.STATIC.STATES.GENERIC_ERROR';
    const iconSrc = variant === 'connection' ? wifiIcon : warningIcon;

    return (
        <Box
            className="StaticSearch-error"
            role="alert"
            sx={theme => ({
                alignItems: 'center',
                backgroundColor: (theme.vars || theme).palette.common.white,
                borderBottom: '1px solid #e0e0e0',
                borderTop: '1px solid #e0e0e0',
                boxSizing: 'border-box',
                color: '#b72d2d',
                display: 'flex',
                gap: '8px',
                height: '40px',
                padding: '8px 16px',
                width: '100%',
            })}
        >
            <Box
                alt=""
                aria-hidden
                className="StaticSearch-error-icon"
                component="img"
                decoding="async"
                src={iconSrc}
                sx={{
                    display: 'block',
                    flexShrink: 0,
                    height: 24,
                    width: 24,
                }}
            />
            <Box
                className="StaticSearch-error-message"
                component="p"
                sx={theme => ({
                    color: 'inherit',
                    flex: 1,
                    fontFamily: (theme as Theme).typography.fontFamily,
                    fontSize: '1rem',
                    letterSpacing: '0.15px',
                    lineHeight: 1.5,
                    margin: 0,
                    minWidth: 0,
                    whiteSpace: 'normal',
                })}
            >
                {l(messageCode)}
            </Box>
        </Box>
    );
}

export default StaticSearchErrorPanel;
